import { compose } from "redux";
import { KeyStringValue } from "../interfaces";

// for react routing
export const basePath = process.env.REACT_APP_BASE_PATH || "/";

// Base URL for the app - set based on environment / injected string
export function ApiBaseUrl() {
  const lookup: KeyStringValue = {
    "pfabankfindui-n.app.cloud.gov": "https://pfabankapi-n.app.cloud.gov/api",
    "pfabankfindui-d.app.cloud.gov": "https://pfabankapi-d.app.cloud.gov/api",
    "pfabankfindui-s.app.cloud.gov": "https://pfabankapi-s.app.cloud.gov/api",
    "pfabankfindui-q.app.cloud.gov": "https://pfabankapi-q.app.cloud.gov/api",
    "pfabankfindui.app.cloud.gov": "https://pfabankapi.app.cloud.gov/api",
    "banks-n.data.fdic.gov": "https://pfabankapi-n.app.cloud.gov/api",
    "banks-d.data.fdic.gov": "https://pfabankapi-d.app.cloud.gov/api",
    "banks-s.data.fdic.gov": "https://pfabankapi-s.app.cloud.gov/api",
    "banks-q.data.fdic.gov": "https://pfabankapi-q.app.cloud.gov/api",
    "banks.data.fdic.gov": "https://pfabankapi.app.cloud.gov/api",
    "localhost": "http://localhost:3000/api",
  };

  return process.env.REACT_APP_API_BASE_URL || lookup[window.location.hostname];
}

export function LoginGovBaseUrl() {
  const lookup: KeyStringValue = {
    "pfabankfindui-n.app.cloud.gov": "https://secure.login.gov",
    "pfabankfindui-d.app.cloud.gov": "https://secure.login.gov",
    "pfabankfindui-s.app.cloud.gov": "https://secure.login.gov",
    "pfabankfindui-q.app.cloud.gov": "https://secure.login.gov",
    "pfabankfindui.app.cloud.gov": "https://secure.login.gov",
    "banks-n.data.fdic.gov": "https://secure.login.gov",
    "banks-d.data.fdic.gov": "https://secure.login.gov",
    "banks-s.data.fdic.gov": "https://secure.login.gov",
    "banks-q.data.fdic.gov": "https://secure.login.gov",
    "banks.data.fdic.gov": "https://secure.login.gov",
    "localhost": "https://idp.int.identitysandbox.gov",
  };

  return process.env.REACT_APP_API_BASE_URL || lookup[window.location.hostname];
}

export function LoginGovClientId() {
  const lookup: KeyStringValue = {
    "pfabankfindui-n.app.cloud.gov": "urn:gov:gsa:openidconnect.profiles:sp:sso:fdic:bfs",
    "pfabankfindui-d.app.cloud.gov": "urn:gov:gsa:openidconnect.profiles:sp:sso:fdic:bfs",
    "pfabankfindui-s.app.cloud.gov": "urn:gov:gsa:openidconnect.profiles:sp:sso:fdic:bfs",
    "pfabankfindui-q.app.cloud.gov": "urn:gov:gsa:openidconnect.profiles:sp:sso:fdic:bfs",
    "pfabankfindui.app.cloud.gov": "urn:gov:gsa:openidconnect.profiles:sp:sso:fdic:bfs",
    "banks-n.data.fdic.gov": "urn:gov:gsa:openidconnect.profiles:sp:sso:fdic:bfs",
    "banks-d.data.fdic.gov": "urn:gov:gsa:openidconnect.profiles:sp:sso:fdic:bfs",
    "banks-s.data.fdic.gov": "urn:gov:gsa:openidconnect.profiles:sp:sso:fdic:bfs",
    "banks-q.data.fdic.gov": "urn:gov:gsa:openidconnect.profiles:sp:sso:fdic:bfs",
    "banks.data.fdic.gov": "urn:gov:gsa:openidconnect.profiles:sp:sso:fdic:bfs",
    "localhost": "urn:gov:gsa:openidconnect.profiles:sp:sso:fdic:bfsdev",
  };

  return process.env.REACT_APP_API_BASE_URL || lookup[window.location.hostname];
}

export function AppUrl(app: string) {
  const staticPaths = {
    HomePage: "/",
    BankFind: "/bankfind",
    OSCR: "/oscr",
    Failures: "/failures",
    HSOB: "/historical",
    FinancialReporting: "/financialreporting",
    PeerGroup: "/peergroup",
    SOD: "/SOD",
    Help: "/help",
    BulkData: "/bulkData",
  };
  const appUrlLookup: { [key: string]: KeyStringValue } = {
    "localhost": {
      ...staticPaths,
      API: "http://localhost:3000/docs",
    },
    "pfabankfindui-n.app.cloud.gov": {
      ...staticPaths,
      API: "https://api.data.gov/TEST/fdic/banks-n/docs/",
    },
    "pfabankfindui-d.app.cloud.gov": {
      ...staticPaths,
      API: "https://api.data.gov/TEST/fdic/banks-d/docs/",
    },
    "pfabankfindui-s.app.cloud.gov": {
      ...staticPaths,
      API: "https://pfabankapi-s.app.cloud.gov/docs",
    },
    "pfabankfindui-q.app.cloud.gov": {
      ...staticPaths,
      API: "https://api.data.gov/TEST/fdic/banks-q/docs/",
    },
    "pfabankfindui.app.cloud.gov": {
      ...staticPaths,
      API: "https://api.fdic.gov/banks/docs/",
    },
    "banks-n.data.fdic.gov": {
      ...staticPaths,
      API: "https://api.data.gov/TEST/fdic/banks-n/docs/",
    },
    "banks-d.data.fdic.gov": {
      ...staticPaths,
      API: "https://api.data.gov/TEST/fdic/banks-d/docs/",
    },
    "banks-s.data.fdic.gov": {
      ...staticPaths,
      API: "https://pfabankapi-s.app.cloud.gov/docs",
    },
    "banks-q.data.fdic.gov": {
      ...staticPaths,
      API: "https://api.data.gov/TEST/fdic/banks-q/docs/",
    },
    "banks.data.fdic.gov": {
      ...staticPaths,
      API: "https://api.fdic.gov/banks/docs/",
    },
    "api.fdic.gov": {
      ...staticPaths,
      API: "https://api.fdic.gov/banks/docs/",
    },
  };
  return appUrlLookup[window.location.hostname][app];
}

// Set the limit for how many records the API will return (API limit ~10k)
export const apiResultLimit = 25;

// Setup react DevTools
// https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
export const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const REPORT_STRUCTURE_APP_ID = "oscr";

export const BANK_FIND_APP_ID = "bankfind";

export const BANK_FIND_SUITE_ID = "bankfind-suite";
